/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min
    }

    let endTimeG

    function cutDownTime() {
        let nowTime = new Date()
        let endTime = new Date(endTimeG)

        let leftTime = endTime.getTime() - nowTime.getTime()
        if (leftTime < 0) {
            setupNewCountdown()
            leftTime = 0
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60)
        leftH = leftH >= 10 ? leftH : '0' + leftH
        leftM = leftM >= 10 ? leftM : '0' + leftM
        leftS = leftS >= 10 ? leftS : '0' + leftS

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        }
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9)
        const currentTime = new Date()
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
    }
    let intervalId
    let prods = window.product
    function getCur() {
        let color = $('#sp-color div.active').attr('data-val')
        // let size = $('#sp-type div.active').attr('data-val')

        return prods.find(item => item.option1 == color 
            // && item.option2 == size
        )
    }
    function changePrice() {
        let num = $('#calcNumber').val()
        let price = ((getCur().price * num) / 100).toFixed(2)
        let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
        // if(num == 1){
        //   price = (getCur().price * num / 100).toFixed(2)
        // }else if(num == 2){
        //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
        // }else if(num == 3){
        //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
        // }else {
        //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
        // }
        price = (price + '').replace('.', ',')
        compare = (compare + '').replace('.', ',')
        $('#sp_price1').html('€' + price)
        $('#sp_price2').html('€' + compare)
        // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        // $(".product-part .brand .num").html(off_font);
    }
    // 弹窗 start
    var main_id = "";
    $('.emitCheckout').click(function () {
        let num = $("#calcNumber").val()
        //   console.log('1111')
        main_id = getCur().id
        //   main_id = $(this).siblings('.select_span').find('span.on').data('id')
        window.location.href = "/cart/" + getCur().id + ":" + num;
    })
    $('.sp-reduce').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) - 1
        if (num > 0) {
            input.value = num
        }
        changePrice()
    })
    $('.sp-add').click(function () {
        let input = $(this).siblings('input')[0]
        let num = Number(input.value) + 1
        input.value = num
        changePrice()
    })
    $('.sp-option').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')

        let colorOptions = $('#sp-color .sp-option.active').index()
        // let typeOptions = $("#sp-type .sp-option.active").index();
        let typeOptions = 0;
        _index = colorOptions
        // console.log(typeOptions);
        if (typeOptions == 1) {
            $(".product_num").text(`x2`)
        } if (typeOptions == 2) {
            $(".product_num").text(`x4`)
        } if (typeOptions == 0) {
            $(".product_num").text(``)
        }
        if(colorOptions>2){
            $(".sp-img-p").css('height','380px').css('margin-top','100px').css('margin-left','0')
        }else{
            $(".sp-img-p").css('height','590px').css('margin-top','0').css('margin-left','122px')
        }

        if (_index > 8) {
            $('.free-img').show()
        } else {
            $('.free-img').hide()
        }
        $('.product-part  .sp-img-p')[0].src = spImgList[_index]
        changePrice()
        // _swiper.slideToLoop(_index);
    })

    $(function () {
        // 购物车加购动效
        $('.cart-btn').click(function () {
            $(this).children('img').addClass('on')
            $('.sp-header-top .sp-cart .sp-num').show()
            setTimeout(function () {
                $('.cart-btn').children('img').removeClass('on')
            }, 500)
            $('.sp-header-top .sp-cart').addClass('on')
            setTimeout(function () {
                $('.sp-header-top .sp-cart').removeClass('on')
            }, 500)
        })

        let initNum = 0
        $('.product-part .cart-btn').click(function () {
            let spNum = $('.product-part #calcNumber')[0].value
            initNum += Number(spNum)

            // $("#calcNumber").val(1);
            var data = {
                id: getCur().id,
                quantity: $('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                    $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
                        $('#cardNum').html(result.item_count)
                        $('#cardNum').removeClass('sp-gray')
                    })
                },
                dataType: 'json',
            })
            //   $('#cardNum').html(initNum)
            //   $('#cardNum').removeClass('sp-gray')
            // handleAddToCart(initNum);

            var imgs = $('.product-part .sp-img-inner').find('img')

            imgs.each(function () {
                var $img = $(this)
                var flyer = $img[0].cloneNode(true)
                console.log(flyer, '888')
                flyer.classList.add('sp_clone')

                $('#shopping').append(flyer)
                $(flyer).css({
                    width: $img[0].width,
                    height: $img[0].height,
                    background: '#e7e9ef',
                    position: 'fixed',

                    top: $img[0].offsetTop,
                    left: $img.offset().left,
                    'z-index': 99,
                })

                let finish = $('.sp-cart')
                $(flyer).animate(
                    {
                        top: finish[0].offsetTop + $('.time-part').height(),
                        left: finish[0].offsetLeft + finish.width() / 2,
                        width: 50,
                        height: 50,
                        opacity: 0.4,
                    },
                    500,
                    'linear',
                    function () {
                        $(this).animate(
                            {
                                width: 0,
                                height: 0,
                                opacity: 0,
                            },
                            0,
                            function () {
                                $(this).detach()
                            }
                        )
                    }
                )
            })
        })
    })

    function getCutDownTime() {
        setupNewCountdown()
        if (intervalId) clearInterval(intervalId)
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime()
            $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
            $('.sp_top_cut_down .sp_left_view .sp_minute').html(
                cutDownTimeText.minute
            )
            $('.sp_top_cut_down .sp_left_view .sp_second').html(
                cutDownTimeText.second
            )
        }, 1000)
    }

    getCutDownTime()

    let spImgList = [
        'https://cdn.shopify.com/s/files/1/0666/4221/5149/files/1_69be62e8-0f3f-408a-b3c8-a0804b1bcd1b.png?v=1779186572',
        'https://cdn.shopify.com/s/files/1/0666/4221/5149/files/2_9ef5c3c9-c1be-4b93-b759-2938a056963e.png?v=1779186572',
        'https://cdn.shopify.com/s/files/1/0666/4221/5149/files/3_994b5bcf-4fa9-478a-87eb-fc9c883f0d11.png?v=1779186572',

        'https://cdn.shopify.com/s/files/1/0655/0080/7373/files/black_gray.png?v=1780387080',
        'https://cdn.shopify.com/s/files/1/0655/0080/7373/files/black2.png?v=1780387080',
        'https://cdn.shopify.com/s/files/1/0655/0080/7373/files/gray2.png?v=1780387080',
        'https://cdn.shopify.com/s/files/1/0655/0080/7373/files/double2.png?v=1780387080',
        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-b5.png',
        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-b6.png',

        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-c1.png',
        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-c2.png',
        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-c3.png',
        'https://cdn.shopify.com/s/files/1/0675/5234/6360/files/20250717-c4.png',
    ]

    //   new Swiper('.sp-swiper3', {
    //     autoplay: true,
    //     autoplay: {
    //       disableOnInteraction: false,
    //     },
    //     effect: 'flip',
    //     loop: true,
    //     pagination: {
    //       el: '.sp-pagination1',
    //       type: 'bullets',
    //       clickable: true,
    //     },
    //   })

    function mainRender() {
        $(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)

            window.addEventListener(
                'resize',
                (function () {
                    var timer
                    return function () {
                        if (timer) clearTimeout(timer)
                        timer = setTimeout(function () {
                            $('#root').css('zoom', 'normal')
                            let scale = document.body.clientWidth / 1080
                            $('#root').css('zoom', scale)
                        }, 100)
                    }
                })()
            )
        })

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
            const config = {
                rootMargin: '0px 0px 1300px 0px',
                threshold: 0,
            }

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target
                        const dataSrc = image.getAttribute('data-src')
                        image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image) // 停止观察该图片
                    }
                })
            },
                config)

            images.forEach(function (image) {
                lazyLoadObserver.observe(image) // 开始观察每个图片
            })
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach(subArray => {
                    subArray.forEach(url => {
                        const img = new Image()
                        img.src = url
                    })
                })
            } else {
                // 处理一维数组
                imageArray.forEach(url => {
                    const img = new Image()
                    img.src = url
                })
            }
        }

        lazyLoadImages()

        preloadImages(spImgList)

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]')
        links.forEach(function (link) {
            link.addEventListener('click', function (event) {
                event.preventDefault() // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById('shopping') // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop
                let _topHeight =
                    $('.time-part').height() + $('.sp-header-top').height() - 10
                window.scroll({
                    top:
                        offsetTop * $('div#root').css('zoom') -
                        _topHeight * $('div#root').css('zoom'),
                    behavior: 'smooth', // 使用 smooth 实现平滑滚动
                }) // 方式二
            })
        })

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera
        var isAndroid = /android/i.test(userAgent)
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log('Android')
        } else if (isIOS) {
            console.log('iOS')
        } else if (isPC) {
            console.log('PC')
        } else {
            $('.sp_system').css('letter-spacing', '-4px')
        }
    }

    mainRender()

    $('.product-box .sp-opt').click(function () {
        $(this).siblings().removeClass('active')
        $(this).addClass('active')
        let _index = $(this).index()

        $(this)
            .parents('.product-box')
            .find('.sp-p-img')
            .eq([_index])
            .show()
            .siblings('.sp-p-img')
            .hide()
    })

    //   $('.sp-option').click(function () {
    //     $(this).siblings().removeClass('active')
    //     $(this).addClass('active')
    //     // style选项

    //     let colorOptions = $('#sp-color1 .sp-option.active').index()
    //     let colorOptions2 = $('#sp-color2 .sp-option.active').index()
    //     $('#spimg1')[0].src = spImgList[colorOptions]
    //     $('#spimg2')[0].src = spImgList[colorOptions2]
    //   })

    //   $('.sp-btn-pop').click(function () {
    //     $('.sp-mask').css('display', 'flex')
    //     $('.sp-pop').show()
    //   })
    // 展示多选商品
    //   $('.product-box2 .sp-btn-style').click(function () {
    //     $('.sp-mask').css('display', 'flex')
    //     $('.sp-pop2').show()
    //     $('.sp-pop').hide()

    //     // $(".sp-pop").show();
    //   })
    // 关闭弹窗按钮
    $('.sp-btn-style3').click(function () {
        let num = $("#calcNumber").val()
        const id = $(this).siblings('.sp-opt-group').find('.active').data('id')
        console.log(id, "id")
        window.location.href = '/cart/' + id + ':' + num
    })
    $('.sp-btn-style2').click(function () {
        let num = $("#calcNumber").val()
        const id1 = $('#sp-color1').find('.active').data('id')
        // const id2 = $('#sp-color2').find('.active').data('id')
        const url = `/cart/${id1}:${num}`
        window.location.href = url
    })
    $('.sp-pop .sp-close-btn').click(function (e) {
        $('.sp-mask').hide()
        $('.sp-pop2').hide()
        $('.sp-pop').hide()
    })
    $('.sp-pop2 .sp-close-btn').click(function (e) {
        $('.sp-mask').hide()
        $('.sp-pop2').hide()
    })

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName('gradually')
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll('span')
        const paragraph = gradually.querySelector('.sp-sub-title')

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`
                            span.style.animationDelay = `${index * 0.1}s`

                            const i = span.querySelector('i')
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`
                                i.style.animationDelay = `${index * 0.1}s`
                            }
                        })

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
                            paragraph.style.animationDelay = `${totalDelay}s`
                        }

                        observer.unobserve(gradually)
                    }
                })
            },
            {
                threshold: 0.3,
            }
        )
        observer.observe(gradually)
    }

    const tabs = $('.sp-tab')

    let currentIndex = 0 // 当前展示的tab索引

    function nextTabFunc() {
        const currentTab = tabs[currentIndex]
        // 当前tab开始动画
        currentTab.classList.add('sp-tab-ani')

        let nextIndex = (currentIndex + 1) % tabs.length
        const nextTab = tabs[nextIndex]

        setTimeout(() => {
            currentTab.classList.remove('sp-tab-ani')
        }, 2500)

        currentIndex = (currentIndex + 1) % tabs.length
        setTimeout(nextTabFunc, 1500)
    }

    nextTabFunc()

    var slideW = 529 //一张图300px, 每面四张角度22.5（PI/8），中心角度PI/16， 每面3张角度30（PI/6），中心角度PI/12
    var radius = (slideW * 0.5) / Math.sin(Math.PI / 12) //半径。圆心并不是视点中心，视点在1200px

    carouselSwiper = new Swiper('#carousel .swiper', {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 3,
        grabCursor: true,
        autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
        },
        // effect: "coverflow",
        freeMode: true,
        speed: 4000, //匀速时间
        on: {
            progress: function (swiper, progress) {
                for (i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i)
                    var slideProgress = this.slides[i].progress
                    const translateX =
                        slideProgress *
                        (slideW / 2.5 -
                            (Math.cos(slideProgress * (1 / 6) * Math.PI) * slideW * 1.2) /
                            2.5) +
                        'px' //调整图片间距，根据图片宽度改变数值实现自适应
                    const rotateY = slideProgress * 30 //图片角度
                    const translateZ =
                        radius -
                        Math.cos(slideProgress * (1 / 6) * Math.PI) * radius -
                        150 +
                        'px' //调整图片远近，刚好4个在画框内
                    slide.transform(
                        'translateX(' +
                        translateX +
                        ') translateZ(' +
                        translateZ +
                        ') rotateY(' +
                        rotateY +
                        'deg)'
                    )
                }
            },
            setTransition: function (swiper, transition) {
                for (var i = 0; i < this.slides.length; i++) {
                    var slide = this.slides.eq(i)
                    slide.transition(transition)
                }
            },
        },
    })
})
